import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    isLoadingToggle: false,
    isSuccess: false,
    isError: false,
    taxDeclaration_data: [],
    taxExecutive_data: [],
    taxEmployee_toggleInfo: false
}

export const TaxDeclarationReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.TAX_DECLARATION_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_DECLARATION_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxDeclaration_data: action.payload?.data?.data
            };
        case ActionTypes.TAX_DECLARATION_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.TAX_DECLARATION_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
                taxDeclaration_data: []
            };
        case ActionTypes.TAX_DECLARATION_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxDeclaration_data: action.payload?.data?.data
            };
        case ActionTypes.TAX_DECLARATION_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.TAX_DECLARATION_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_DECLARATION_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxDeclaration_data: action.payload?.data?.data
            };
        case ActionTypes.TAX_DECLARATION_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message
            }
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxExecutive_data: action.payload?.data?.data, 
            };
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxExecutive_data: action.payload?.data?.data, 
            };
        case ActionTypes.TAX_DECLARATION_EXECUTIVE_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_REQUEST:
            return {
                ...state,
                isLoadingToggle: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_SUCCESS:
            return {
                ...state,
                isLoadingToggle: false,
                success: true,
                successMessage: action.payload?.message,
                taxEmployee_toggleInfo: action.payload?.data?.data,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_GET_ERROR:
            return {
                ...state,
                isLoadingToggle: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                taxEmployee_toggleInfo: action.payload?.data?.data,
            };
        case ActionTypes.TAX_EMPLOYEE_TOGGLE_INFO_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        default:
            return state;
    }
}
